<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Aktivity -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-12 col-xl-9">
                        <h2>Moja aktivita</h2>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Activity Box -->
                        <div class="o-activity__list">
                            <div v-for="(zaznam, index) in aktivita" class="m-activity__item">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-3 col-lg-2 a-activity__date">{{ zaznam.created_at.replace(/-/g, ".").replace(/:..$/g, "") }}</div>
                                    <div class="col-12 col-sm-12 col-md-9 col-lg-10">{{ zaznam.pouzivatel_log_message }}</div>
                                </div>
                            </div>
                        </div>
                        <!-- .Activity Box -->

                    </div>
                    <!-- .Aktivity -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
            this.getPouzivatelLog()
        },
        data() {
            return {
                aktivita: [],

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            getPouzivatelLog() {
                EventService.getPouzivatelLog()
                    .then(response => {
                        //console.log(response.data)
                        this.aktivita = response.data.data
                        if (response.data.data.length == 0) {
                            var today = EventService.getCurrentDate(0)
                            this.aktivita = [{
                                created_at: today,
                                pouzivatel_log_message: 'Žiadna aktivita'
                            }]
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            }
        }
    }
</script>